module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 87300.c9915f12.png";